import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import ParticipantDialog from './ParticipantDialog';
import { participantsOptions } from '../Constants';

const StyledCard = styled(Card)(({ theme }) => ({
  background: theme.palette.booking.background,
  marginBottom: '1rem'
}));

const StyledHeader = styled(Box)(({ theme, booking, index }) => ({
  marginBottom: '0.7rem',
  paddingTop: 0,
  fontSize: '1.25rem',
  fontWeight: '700',
  color: theme.palette.booking.header,
  opacity: booking === participantsOptions.bookingPerson && index === 0 ? '0.6' : '1'
}));

const StyledParticipantInfo = styled(Typography)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem'
}));

const StyledGridItem = styled(Grid)(({ theme }) => ({
  paddingTop: '0.75rem !important',
  paddingBottom: '0.75rem',
  color: theme.palette.booking.header
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '1.12rem',
  color: theme.palette.booking.header
}));

const StyledDeleteIcon = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.error.main
}));

const StyledBox = styled(Box)(({ booking, index }) => ({
  opacity: booking === participantsOptions.bookingPerson && index === 0 ? '0.6' : '1'
}));

const ParticipantCard = ({
  participant: {
    generalInformation: { firstName, lastName },
    contactInformation: { email, mobile },
    id
  },
  index,
  bookingPersonRadio,
  participants,
  setParticipants,
  configuration = {},
  isEventFree = false,
  isEventIlias
}) => {
  const handleDelete = (event) => {
    const id = event.currentTarget.id;
    setParticipants(participants.filter((participant) => participant.id !== id));
  };

  return (
    <StyledCard variant='outlined'>
      <CardContent
        sx={{
          ':last-child': {
            paddingBottom: 0
          }
        }}
      >
        <Grid container spacing={2} sx={{ padding: 0 }}>
          <StyledGridItem item md={10} xs={10}>
            <Box sx={{ mt: 0 }}>
              <StyledHeader
                booking={bookingPersonRadio}
                index={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
              >
                <PersonIcon />
                <StyledTypography>{`${firstName} ${lastName}`}</StyledTypography>
              </StyledHeader>

              <StyledBox
                booking={bookingPersonRadio}
                index={index}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.5rem'
                }}
              >
                {email && (
                  <StyledParticipantInfo>
                    <EmailIcon />
                    <Typography component='span'>{email}</Typography>
                  </StyledParticipantInfo>
                )}

                {mobile && (
                  <StyledParticipantInfo>
                    <PhoneIcon />
                    <Typography component='span'>{mobile}</Typography>
                  </StyledParticipantInfo>
                )}
              </StyledBox>
            </Box>
          </StyledGridItem>
          <StyledGridItem item md={2} xs={2}>
            {index > 0 && (
              <Box sx={{ textAlign: 'end' }}>
                <ParticipantDialog
                  mode={'edit'}
                  participants={participants}
                  setParticipants={setParticipants}
                  id={id}
                  configuration={configuration}
                  isEventFree={isEventFree}
                  isEventIlias={isEventIlias}
                />

                <Button sx={{ minWidth: '1.5rem' }} onClick={handleDelete} id={id}>
                  <StyledDeleteIcon id={id} />
                </Button>
              </Box>
            )}
          </StyledGridItem>
        </Grid>
      </CardContent>
    </StyledCard>
  );
};

export default ParticipantCard;
